// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-icon{height:37px;width:30px}", "",{"version":3,"sources":["webpack://./src/app/components/Common/FileIcon/FileIcon.css"],"names":[],"mappings":"AAAA,WAEE,WAAY,CADZ,UAEF","sourcesContent":[".file-icon {\n  width: 30px;\n  height: 37px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
